export default __webpack_public_path__ + "static/media/phone-support-taller.141aac95.png";